import React from "react";
import TermsAndConditionsMDX from "../../docs/Terms-and-conditions.mdx";

const TermsAndConditions: React.FC = () => {
  return (
    <div className=" max-w-4xl m-auto">
      <TermsAndConditionsMDX />
    </div>
  );
};

export default TermsAndConditions;
